export default "__VITE_ASSET__1xFvPco1__"